import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Typography,
  Paper,
  Grid,
  CircularProgress,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { baseurl } from "domain";

function BookingDetails() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const payment_id = queryParams.get("payment_id");

  const a_name = localStorage.getItem("name");

  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openRescheduleDialog, setOpenRescheduleDialog] = useState(false);
  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");
  const [date, setDate] = useState("");
  const [availableSlots, setAvailableSlots] = useState([]);

  // const [openRescheduleDialog, setOpenRescheduleDialog] = useState(false);
  const [openConfirmRescheduleDialog, setOpenConfirmRescheduleDialog] = useState(false);
  // const [date, setDate] = useState('');
  // const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const navigate = useNavigate();


  const convertTo12Hour = (time24) => {
    const [hours, minutes] = time24.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  const handleRescheduleClick = () => {
    const existingDate = booking?.date || "";
    setOpenRescheduleDialog(true);
    setDate(existingDate); // Set existing booking date
    setAvailableSlots([]); // Reset
    setSelectedSlot(null);

    if (existingDate) {
      fetchAvailableSlots(existingDate); // Fetch initial slots
    }
  };

  const handleConfirmReschedule = async () => {
    try {
      await axios.post(
        `https://${baseurl}/reschedulePCHBooking?date=${date}&start_time=${selectedSlot.start}&end_time=${selectedSlot.end}&payment_id=${payment_id}&a_name=${a_name}`
      );
      alert("Booking successfully rescheduled.");
      setOpenConfirmRescheduleDialog(false);
      setOpenRescheduleDialog(false);
      fetchBookingDetails(); // Refresh data
    } catch (error) {
      console.error("Error rescheduling booking:", error);
      alert("Failed to reschedule booking.");
    }
  };


  useEffect(() => {
    if (payment_id) {
      fetchBookingDetails();
    }
  }, [payment_id]);

  const fetchBookingDetails = async () => {
    try {
      const response = await axios.get(
        `https://${baseurl}/getBookingDetails?payment_id=${payment_id}`
      );
      setBooking(response.data.booking);
    } catch (error) {
      console.error("Error fetching booking details:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatType = (type) => {
    return type === "press-conf" ? "Press Conference" : "Program";
  };

  const formatDuration = (duration) => {
    return duration === "30" ? "30 minutes" : `${duration / 60} hours`;
  };

  const handleCancelClick = () => {
    setOpenCancelDialog(true);
  };

  const handleBackClick = () => {
    navigate("/managePressConfHall");
  };

  const handleInvoiceClick = (lnk) => {
    if (lnk) {
      window.open(lnk, "_blank");
    }
  };

  const handleCancelBooking = () => {
    setOpenCancelDialog(false);
    setOpenConfirmDialog(true);
  };

  const handleConfirmCancel = async () => {
    try {
      await axios.post(`https://${baseurl}/cancelPCHBooking`, {
        payment_id,
        reason,
        remark,
        a_name,
      });

      alert("Booking successfully canceled.");
      setOpenConfirmDialog(false);
      fetchBookingDetails(); // Refresh details
    } catch (error) {
      console.error("Error canceling booking:", error);
      alert("Failed to cancel booking.");
    }
  };

  const handleRescheduleBooking = () => {
    setOpenRescheduleDialog(true);
    setDate("");
    setAvailableSlots([]);
  };

  const fetchAvailableSlots = async (selectedDate) => {
    try {
      const response = await axios.get(
        `https://${baseurl}/available_slots_conf?date=${selectedDate}&duration=${booking.duration}&type=${booking.subCatType}&payment_id=${booking.payment_id}`
      );
      setAvailableSlots(response.data.available_slots || []);
    } catch (error) {
      console.error("Error fetching available slots:", error);
      setAvailableSlots([]);
    }
  };

  const handleSlotSelect = async (slot) => {
    try {
      await axios.post(
        `https://${baseurl}/rescheduleBooking?payment_id=${payment_id}&date=${date}&start_time=${slot.start}&end_time=${slot.end}`
      );
      alert("Booking successfully rescheduled.");
      setOpenRescheduleDialog(false);
      fetchBookingDetails(); // Refresh data
    } catch (error) {
      console.error("Reschedule error:", error);
      alert("Failed to reschedule booking.");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
          <Typography variant="h4" gutterBottom>
            Booking Details
          </Typography>
          <hr style={{ marginBottom: 22 }} />

          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress />
            </Box>
          ) : booking ? (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Date:</strong> {booking.date}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Event Type:</strong> {booking.subCatType}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Subject:</strong> {booking.subject}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Gov ID:</strong> {booking.govId}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Duration:</strong> {formatDuration(booking.duration)}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Time Slot:</strong> {convertTo12Hour(booking.start_time)} - {convertTo12Hour(booking.end_time)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Name:</strong> {booking.name}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Address:</strong> {booking.address}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Pincode:</strong> {booking.pinCode}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Organization Name:</strong> {booking.insName}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Email:</strong> {booking.email}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Phone Number:</strong> {booking.phnNo}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography><strong>Amount Paid:</strong> ₹ {booking.amount / 100}</Typography>
              </Grid>
              {booking.gstNo && (
                <Grid item xs={12} sm={6}>
                  <Typography><strong>GST NO.:</strong> {booking.gstNo}</Typography>
                </Grid>
              )}
              <Grid item xs={12}>
                <Typography><strong>Booked By:</strong> {booking.bookedBy}</Typography>
              </Grid>
              {booking.remark && (
                <>
                  <Grid item xs={12} sm={6}>
                    <Typography><strong>Remark:</strong> {booking.remark}</Typography>
                  </Grid>
                </>
              )}
              {booking.bookedBy === "Online" && (
                <>
                  <Grid item xs={12} sm={6}>
                    <Typography><strong>Payment ID:</strong> {booking.payment_id}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography><strong>Order ID:</strong> {booking.order_id || "N/A"}</Typography>
                  </Grid>
                </>
              )}

              {/* Action Buttons */}
              <Grid item xs={12} sx={{ mt: 3 }}>
                <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap={2}>

                <Button variant="contained" color="primary" onClick={handleBackClick}>
                    Back
                  </Button>

                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#d32f2f",
                      color: "white !important",
                      "&:hover": { backgroundColor: "#b71c1c" },
                    }}
                    onClick={handleCancelClick}
                  >
                    Cancel
                  </Button>

                  {booking.invoice_link && (
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#4caf50",
                        color: "white !important",
                        "&:hover": { backgroundColor: "#388e3c" },
                      }}
                      onClick={() => handleInvoiceClick(booking.invoice_link)}
                    >
                      Download Invoice
                    </Button>
                  )}

                  <Button variant="contained" color="primary" onClick={handleRescheduleClick}>
                    Re-Schedule
                  </Button>
                </Box>
              </Grid>
            </Grid>
          ) : (
            <Typography color="error">No booking details found.</Typography>
          )}
        </Paper>
      </Container>

      {/* Cancel Reason Dialog */}
      <Dialog open={openCancelDialog} onClose={() => setOpenCancelDialog(false)}>
        <DialogTitle>Cancel Booking</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Reason"
            variant="outlined"
            margin="dense"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          <TextField
            fullWidth
            label="Remark"
            variant="outlined"
            margin="dense"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCancelDialog(false)} color="secondary">
            Back
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: "red", color: "white !important" }}
            onClick={handleCancelBooking}
          >
            Cancel Booking
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openRescheduleDialog} onClose={() => setOpenRescheduleDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Reschedule Booking</DialogTitle>
        <hr />
        <DialogContent>
          <Grid container spacing={3}>
            {/* Date Picker */}
            <Grid item xs={12}>
              <TextField
                sx={{ width: 220 }}
                label="Date"
                type="date"
                value={date}
                onChange={(e) => {
                  const selected = e.target.value;
                  setDate(selected);
                  fetchAvailableSlots(selected);
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Slots */}
            <Grid item xs={12}>
              <Typography variant="subtitle1">Available Slots:</Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                {availableSlots.length > 0 ? (
                  availableSlots.map((slot, index) => (
                    <Button
                      key={index}
                      sx={{ color: "black !important" }}
                      variant={selectedSlot?.start === slot.start ? "contained" : "outlined"}
                      onClick={() => setSelectedSlot(slot)}
                    >
                      {convertTo12Hour(slot.start)} - {convertTo12Hour(slot.end)}
                    </Button>
                  ))
                ) : (
                  <Typography color="text.secondary" sx={{ mt: 1 }}>
                    No slots available for selected date.
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRescheduleDialog(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={() => setOpenConfirmRescheduleDialog(true)}
            variant="contained"
            color="primary"
            disabled={!selectedSlot}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openConfirmRescheduleDialog} onClose={() => setOpenConfirmRescheduleDialog(false)}>
        <DialogTitle>Confirm Reschedule</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to reschedule the booking to <strong>{date}</strong> from{" "}
            <strong>{selectedSlot ? convertTo12Hour(selectedSlot.start) : ""}</strong> to{" "}
            <strong>{selectedSlot ? convertTo12Hour(selectedSlot.end) : ""}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmRescheduleDialog(false)} color="secondary">
            No
          </Button>
          <Button variant="contained" color="primary" onClick={handleConfirmReschedule}>
            Yes, Reschedule
          </Button>
        </DialogActions>
      </Dialog>



      {/* Final Confirm Cancel Dialog */}
      <Dialog open={openConfirmDialog} onClose={() => setOpenConfirmDialog(false)}>
        <DialogTitle>Confirm Cancellation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to cancel this booking?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDialog(false)} color="secondary">
            No
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#d32f2f", color: "white !important" }}
            onClick={handleConfirmCancel}
          >
            Yes, Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Reschedule Dialog */}

      <Footer />
    </DashboardLayout>
  );
}

export default BookingDetails;
